import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

/** Replica o keep-alive do AngularJS: chamadas periódicas a /api/verify. */
@Injectable({
  providedIn: 'root'
})
export class SessionKeepAliveService implements OnDestroy {
  private verifySubscription?: Subscription;

  private readonly VERIFY_INTERVAL = 120000; // 2 minutos

  constructor(private http: HttpClient) {}

  start(): void {
    // Desabilitado em localhost: servidor de sessão só aceita origens *.betha.cloud (CORS)
    const hostname = this.getHostname();
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return;
    }

    this.verifySubscription = interval(this.VERIFY_INTERVAL).subscribe(() => {
      this.verifySession();
    });
    this.verifySession();
  }

  stop(): void {
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
  }

  private verifySession(): void {
    const baseUrl = this.getLoginSessionVerifierUrl();
    const url = `${baseUrl}/api/verify`;
    
    this.http.get<{ status: string }>(url, { withCredentials: false })
      .pipe(
        catchError(error => {
          return of(null);
        })
      )
      .subscribe();
  }

  private getLoginSessionVerifierUrl(): string {
    const hostname = this.getHostname();

    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      return 'https://login-session-verifier.test.betha.cloud';
    } else if (hostname.includes('test.betha.cloud')) {
      return 'https://login-session-verifier.test.betha.cloud';
    } else {
      return 'https://login-session-verifier.betha.cloud';
    }
  }

  ngOnDestroy(): void {
    this.stop();
  }

  /** Extraído como método (em vez de ler `window.location.hostname` inline) para ser espionável em teste. */
  private getHostname(): string {
    return window.location.hostname;
  }
}
